import React, { useState, useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { basicService, vaultImportPasswordsService } from '@app/services';
import { PageLoader, PasslyButton } from '@app/components';
import { genericErrorString } from '@app/helpers';
import { setExceptionHandler } from '@app/store/actions';
import { useDispatch } from 'react-redux';

interface IReceivedData {
    file: any;
    vault: string;
    org: string;
    vaultFolder: string;
    encryptionKey: string;
}

const DoImportComponent = (props: IReceivedData) => {
    const { translation } = useTypedTranslation();
    const dispatch = useDispatch();

    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const [savedSuccessfully, setSavedSuccessfully] = useState<boolean>(false);

    useEffect(() => {
        dispatch(setExceptionHandler(true));

        if (props.file.length === 0 || props.vault === '' || props.org === '' || props.vaultFolder === '' || props.encryptionKey === '') {
            setErrorMessage(translation('IMPORTER_MIGRATE_ERROR'));
        }
        else {
            // try to send data to server
            let formData = new FormData();
            formData.append('file', props.file[0]);

            vaultImportPasswordsService.importPasswords(formData, props.encryptionKey, props.org, props.vault, props.vaultFolder, handleError, handleSuccess);
        }
    }, []);

    const handleSuccess = (response: any) => {
        setSavedSuccessfully(true);
    };

    const handleError = (response: any) => {
        setErrorMessage(genericErrorString(response));
    };

    const handleBack = () => {
        basicService.redirect('/passwordserver/import/password-import');
    };

    return (
        <>
            {errorMessage ?
                <>
                    <div className='passwordImportChoice__error'>{errorMessage}</div>
                    <div className='passwordImportChoice__wizardButtons-buttons'>
                        <PasslyButton
                            id='importPasswordsBack'
                            onClick={handleBack}
                            variant='outlined'
                        >
                            {translation('BACK')}
                        </PasslyButton>
                    </div>
                </>
                :
                <>
                    {savedSuccessfully ?
                        <div className='passwordImportChoice'>
                            <div className='passwordImportChoice__doImport-margin'>{translation('IMPORTER_MIGRATE_CONFIRM')}</div>
                            <div className='passwordImportChoice__doImport-margin passwordImportChoice__wizardButtons-buttons'>
                                <PasslyButton color='primary' variant='contained' onClick={() => { basicService.redirect('/passwordserver/vaults'); }}>
                                    {translation('GO_TO_VAULTS')}
                                </PasslyButton>
                            </div>
                        </div>
                        :
                        <PageLoader />
                    }
                </>
            }
        </>
    );
};

export default DoImportComponent;